// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2ZfJD","formContainer":"styles_formContainer__1ORC7","logo":"styles_logo__1uFdK","link":"styles_link__3-aLV","text":"styles_text__R4OiE"};